import { useEffect, useState } from 'react'
import { getActiveRole } from '@fs/zion-admin-mode'

export default function useActiveRole(): { role: string | undefined } {
  const [role, setRole] = useState<string>('')

  useEffect(() => {
    let isCurrent = true
    getActiveRole()
      .then((adminType: string) => isCurrent && setRole(adminType))
      .catch(console.error)
    return () => {
      isCurrent = false
    }
  }, [])

  // We intentionally did not add a loading state to this because we thought it was best not to have this block the user experience. Yes, this could make the data admin experience worse and we are ok with that. In the off chance that this data admin call does take a long time to return we would rather have it degrade the data admin and not the normal user experience.
  return { role }
}
